// extracted by mini-css-extract-plugin
export var playButton = "videoPlayButton-module--playButton--5f262";
export var playButtonCanvas = "videoPlayButton-module--playButtonCanvas--b80db";
export var playButtonContainer = "videoPlayButton-module--playButtonContainer--e82f2";
export var playButtonTimer = "videoPlayButton-module--playButtonTimer--09671";